import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

// @tcc
import { getMessage } from 'util/locale';
import { Dropdown } from '@tcc/crate';

// util
import { getZoneNumbersInRange } from './plantingPlanFormUtil';

const baseString = 'vra-planting-plan__num-zones';
const NumZones = ({
  isReviewScriptStep,
  onChangeNumZones,
  maxZoneCount,
  minZoneCount,
  numZonesInActiveScenario,
  plantingPlanParams,
  isSingleZoneRecommendationEnabled,
}) => {
  const { 'num-zones': numZones } = plantingPlanParams;

  const classString = classNames({
    [`${baseString}`]: true,
    'vra-planting-plan-form__fieldset': true
  });

  return isReviewScriptStep ? (
    <section className={classString}>
      <div className='vra-planting-plan-form__inputs-wrapper'>
        <Dropdown
          className='vra-planting-plan-text-input__dropdown'
          key='num-zones-select'
          label={getMessage('select-number-of-zones')}
          options={getZoneNumbersInRange({
            minZoneCount, 
            maxZoneCount, 
            isSingleZoneRecommendationEnabled
          })}
          setValue={onChangeNumZones}
          testId='num-zones-select'
          selectedId={numZones || numZonesInActiveScenario}
        />
      </div>
    </section>
  ) : null;
};

NumZones.propTypes = {
  isReviewScriptStep: propTypes.bool.isRequired,
  maxZoneCount: propTypes.number.isRequired,
  minZoneCount: propTypes.number.isRequired,
  numZonesInActiveScenario: propTypes.number,
  onChangeNumZones: propTypes.func.isRequired,
  plantingPlanParams: propTypes.object.isRequired,
  isSingleZoneRecommendationEnabled: propTypes.bool.isRequired,
};

export default NumZones;
